var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHideSidebar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M21.7 3A1.3 1.3 0 0 1 23 4.3v15.4a1.3 1.3 0 0 1-2.6 0V4.3A1.3 1.3 0 0 1 21.7 3M7.666 6.13a1.034 1.034 0 0 1 1.424 0 .95.95 0 0 1 0 1.374l-3.51 3.388h11.313a1.108 1.108 0 0 1 0 2.215H5.578l3.512 3.387a.95.95 0 0 1 0 1.374c-.393.38-1.03.38-1.424 0l-5.371-5.181a.95.95 0 0 1 0-1.374z"
})));
export default SvgHideSidebar;